import { ROUTE_NAMES } from "Admin/js/Constants/routes";
import { nextTick } from "vue";

export function getMobileTourSteps({ driverInstance, router }) {
    return [
        {
            element: ".workday-pill-tour-step",
            popover: {
                title: "Access Workday controls",
                description:
                    "Before your team can shift in and start tracking time, you need to start the workday. Tap here to access workday controls. This is where the workday is managed.",
                side: "bottom",
                align: "start",
            },
            onNextClick: async () => {
                await router.push({ name: ROUTE_NAMES.MOBILE_WORKDAY });
                driverInstance?.moveNext();
            },
        },
        {
            element: ".workday-controls-tour-step",
            popover: {
                title: "start the workday",
                description:
                    "Tap here to start the workday. Once the workday is active, your team can begin their shifts. This unlocks time tracking for the day.",
                side: "bottom",
                align: "start",
            },
            routeName: ROUTE_NAMES.MOBILE_WORKDAY,
        },
        {
            element: ".shift-controls-tour-step",
            popover: {
                title: "Start your shift",
                description:
                    "After the workday has started, tap here to start your own shift. Your active work time begins from this point. You can pause or end your shift anytime.",
                side: "bottom",
                align: "start",
            },
            routeName: ROUTE_NAMES.MOBILE_WORKDAY,
        },

        {
            element: ".profile-controls-tour-step",
            popover: {
                title: "Open profile controls",
                description:
                    "Tap here to access your profile controls. You can manage personal settings and workspace level options.",
                side: "bottom",
                align: "start",
            },
            onPrevClick: async () => {
                await router.push({ name: ROUTE_NAMES.MOBILE_WORKDAY });
                driverInstance?.movePrevious();
            },
        },

        {
            element: ".dashboard-controls-tour-step",
            popover: {
                title: "View the Dashboard",
                description:
                    "Tap here to open the Dashboard. You can see team stats and its high level overview. This includes the effort tracked across their tasks.",
                side: "bottom",
                align: "start",
            },
        },
        {
            element: ".main-menu-actions-tour-step",
            popover: {
                title: "Open the menu",
                description:
                    "Tap here to open the main menu. From here, you can navigate to all major panels across Kaamfu. Use this to move around the app easily.",
                side: "bottom",
                align: "start",
            },
            onNextClick: async () => {
                const mainMenuActions =
                    document.querySelector(".main-menu-actions");
                if (mainMenuActions) {
                    mainMenuActions.click();
                    await nextTick();
                }
                driverInstance?.moveNext();
            },
        },
        {
            element: ".align-main-menu-controls-tour-step",
            popover: {
                title: "Open Setup",
                description:
                    "Tap here to begin setting up Kaamfu for your organization. Setup guides you through the key steps needed to get started. Completing this ensures your workspace is ready.",
                side: "bottom",
                align: "start",
            },
            onPrevClick: async () => {
                const mainMenuActions =
                    document.querySelector(".main-menu-actions");
                if (mainMenuActions) {
                    mainMenuActions.click();
                    await nextTick();
                }
                driverInstance?.movePrevious();
            },
            onNextClick: async () => {
                const alignMainMenuActions = document.querySelector(
                    ".align-main-menu-controls-tour-step",
                );

                const mainMenuActions =
                    document.querySelector(".main-menu-actions");
                if (alignMainMenuActions) alignMainMenuActions.click();
                if (mainMenuActions) mainMenuActions.click();
                driverInstance?.moveNext();
            },
            onLoad: async () => {
                const mainMenuActions =
                    document.querySelector(".main-menu-actions");
                if (mainMenuActions) {
                    mainMenuActions.click();
                    await nextTick();
                }
            },
        },
        {
            element: "#create_your_personal_profile",
            popover: {
                title: "Create your personal profile",
                description:
                    "Start by setting up your personal profile. Edit your name, country, and add an avatar. This personalizes your experience across the app.",
                side: "bottom",
                align: "start",
            },
            onPrevClick: async () => {
                const mainMenuActions =
                    document.querySelector(".main-menu-actions");
                if (mainMenuActions) {
                    mainMenuActions.click();
                    await nextTick();
                }
                driverInstance?.movePrevious();
            },
            onLoad: async () => {
                const createYourPersonalProfile = document.querySelector(
                    "#create_your_personal_profile",
                );
                if (createYourPersonalProfile) {
                    createYourPersonalProfile.scrollIntoView({
                        behavior: "smooth",
                    });
                    await nextTick();
                }
            },
            routeName: ROUTE_NAMES.MOBILE_ALIGN,
        },
        {
            element: "#create_an_organization_profile",
            popover: {
                title: "Create your organization profile",
                description:
                    "Set up your organization profile here. This defines your workspace and how your team operates.",
                side: "bottom",
                align: "start",
            },
            routeName: ROUTE_NAMES.MOBILE_ALIGN,
            onPrevClick: async () => {
                const createYourPersonalProfile = document.querySelector(
                    "#create_your_personal_profile",
                );
                if (createYourPersonalProfile) {
                    createYourPersonalProfile.scrollIntoView({
                        behavior: "smooth",
                    });
                    await nextTick();
                }
                driverInstance?.movePrevious();
            },
            onLoad: async () => {
                const createAnOrganizationProfile = document.querySelector(
                    "#create_an_organization_profile",
                );
                if (createAnOrganizationProfile) {
                    createAnOrganizationProfile.scrollIntoView({
                        behavior: "smooth",
                    });
                }
                await nextTick();
            },
        },
        {
            element: "#know_what_you_get_from_kaamfu",
            popover: {
                title: "Learn what you get from Kaamfu",
                description:
                    "Watch short tutorials to understand Kaamfu’s core features. These videos explain how work, time, and visibility come together.",
                side: "bottom",
                align: "start",
            },
            onPrevClick: async () => {
                const createAnOrganizationProfile = document.querySelector(
                    "#create_an_organization_profile",
                );
                if (createAnOrganizationProfile) {
                    createAnOrganizationProfile.scrollIntoView({
                        behavior: "smooth",
                    });
                    await nextTick();
                }
                driverInstance?.movePrevious();
            },
            routeName: ROUTE_NAMES.MOBILE_ALIGN,
        },
        {
            element: "#invite_your_team",
            popover: {
                title: "Invite your team",
                description:
                    "Invite your team members to join your organization. Once invited, they can start setting up their own work.",
                side: "bottom",
                align: "start",
            },
            routeName: ROUTE_NAMES.MOBILE_ALIGN,
        },
        {
            element: "#get_help_now",
            popover: {
                title: "Get help from the Kaamfu team",
                description:
                    "Book a session with the Kaamfu team if you need help. You can ask questions or get guided onboarding. Support is available when you need it.",
                side: "bottom",
                align: "start",
            },
            routeName: ROUTE_NAMES.MOBILE_ALIGN,
        },
    ];
}
